<div class="report-page-root-container weekly-sales-component-container">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/weekly-sales-report.svg" style="width: 27px;">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row filter-row">
              <mat-form-field class="year-selection">
                <mat-label>Year</mat-label>
                <mat-select placeholder="Select a year" formControlName="year" (selectionChange)="onYearChange()">
                  <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                    {{ fy.display_year }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="editForm.get('year')?.hasError('required') && (editForm.get('year')?.touched)">
                  Please select Year.
                </mat-error>
              </mat-form-field>
              <div class="row">
                <mat-form-field class="week-selection">
                  <mat-label>Week From</mat-label>
                  <mat-select formControlName="week_from">
                    <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                      {{ week.displayText }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="editForm.get('week_from')?.hasError('required') && (editForm.get('week_from')?.touched)">
                    Please select Week From.
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="week-selection">
                  <mat-label>Week To</mat-label>
                  <mat-select formControlName="week_to">
                    <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                      {{ week.displayText }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="editForm.get('week_to')?.hasError('required') && (editForm.get('week_to')?.touched)">
                    Please select Week To.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- <div class="input-group"> -->
            <div class="row">
              <mat-form-field>
                <mat-label>Shop</mat-label>
                <input type="text" matInput formControlName="shop_id" [matAutocomplete]="autoShop"
                  (input)="filterShops()">
                <mat-autocomplete #autoShop="matAutocomplete" [displayWith]="displayShop"
                  (optionSelected)="onShopSelectionChange()">
                  <mat-option value="ALL">All</mat-option>
                  <mat-option *ngFor="let shop of filteredShopList" [value]="shop">
                    {{ shop.name }}
                  </mat-option>
                </mat-autocomplete>
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearShop()"
                  *ngIf="editForm.get('shop_id')?.value">
                  <mat-icon>close</mat-icon>
                </button>

                <mat-error *ngIf="editForm.get('shop_id')?.hasError('invalidShop') && editForm.get('shop_id')?.touched">
                  Please select a valid shop.
                </mat-error>
              </mat-form-field>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </form>
    </div>
  </div>
</div>